import React from 'react';
import VideoThumbnailRender, {ThumbnailProps} from './VideoThumbnailRender';

export const VideoThumbnail=({...props}:ThumbnailProps):JSX.Element=>{
	return <VideoThumbnailRender {...props}/>;
};
